import React from "react";
import Accordion from "./Accordion";
import "./faq.scss";

const AccordionContent = [
  {
    index: "01",
    question:
      "Does the customer still have access to view their billing data / usage to ensure the AWS partner is invoicing and billing me the correct amount monthly?",
    answer:
      "As the customer, you still have access to view your AWS bills to ensure the right invoice is sent to you by the AWS Partner.",
  },
  {
    index: "02",
    question:
      "What exchange rate am I to make payment with to the AWS Partner?",
    answer:
      "Customer is expected to make payments based on the present day’s (the day the payment is made) exchange rate to the AWS Partner.",
  },
  {
    index: "03",
    question:
      "If I have AWS credits on my AWS Account, what happens to them after I onboard CloudPlexo’s organisation?",
    answer:
      "Your available AWS credits will still be available on your AWS account, and will still continue to apply to your AWS bills until they expire.",
  },
  {
    index: "04",
    question: "What about data security and control?",
    answer:
      "We understand the importance of data security. Our Organization account offers advanced security features such as fine-grained permissions and multi-factor authentication. Your data remains fully under your control while benefiting from heightened security measures.",
  },
  {
    index: "05",
    question: "Is the AWS account onboarding process complex?",
    answer:
      "No, our onboarding process is designed to be seamless. We provide step-by-step guidance and support to ensure a smooth transition of your AWS accounts to our Organization account, minimizing disruptions.",
  },
  {
    index: "06",
    question: "Will I lose autonomy over my AWS resources?",
    answer:
      "No, you'll retain full operational autonomy over your resources. While billing will be centralized, you'll continue to manage and configure your services according to your business needs.",
  },
  {
    index: "07",
    question: "Can I revert to my previous billing structure?",
    answer:
      "Yes, you have the flexibility to revert to your previous billing structure if desired, in accordance with our contract agreement. We focus on delivering value through cost optimization, security, and streamlined management to encourage continued usage.",
  },
  {
    index: "08",
    question: "Will the onboarding disrupt my operations?",
    answer:
      "No, invitations to onboard our Organisation account will not disrupt your operations.",
  },
  {
    index: "09",
    question: "Is there a risk of vendor lock-in?",
    answer:
      "Our service is designed to provide value without creating vendor lock-in. You can choose to revert to your previous billing structure if you decide to discontinue using our service.",
  },
  {
    index: "10",
    question:
      "If I have an Organisation account, can I onboard only a specific set of AWS accounts?",
    answer:
      "Yes, our service is flexible. You can choose to migrate specific AWS accounts that align with your business goals and needs.",
  },
];

const getAccordion = AccordionContent.map((item) => (
  <Accordion
    key={item.question}
    question={item.question}
    answer={item.answer}
    content={item.C}
    index={item.index}
  />
));
function AccordionCard(props) {
  return <div className="col-md-11">{getAccordion}</div>;
}

export default AccordionCard;
